import { useMutation, useQueryClient } from '@tanstack/react-query';
import { callbackFetch, url } from './fetch';
import updatePriceCache from './update-price-cache';
import updateAboutCache from './update-about-cache';

/**
 * API to get stock prices in bulk.
 * Currently used for initializing top nav tabs stock icon and prices
 * See: packages/stock/src/Layout/TopNav/StockTickerTabs/StockTickerTabs.js
 * details: https://ajaib.atlassian.net/wiki/x/5YBDbw
 */
function useStockPrices() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [url],
    mutationFn: callbackFetch,
    onSuccess: (data) => {
      const stockData = data.results;
      updatePriceCache(queryClient, stockData);
      updateAboutCache(queryClient, stockData);
    },
  });
}

export default useStockPrices;
